export default __webpack_public_path__ + "static/media/Goal_15.ee992756.zip";